import { Component, OnInit, Input, ElementRef, Renderer2, ViewEncapsulation } from '@angular/core';
import { AppConfig } from '../../../../app.config';

@Component({
  selector: 'app-round-button',
  templateUrl: './round-button.component.html',
  styleUrls: ['./round-button.component.scss']
})
export class RoundButtonComponent implements OnInit {
  @Input('color')
  color: string;

  disableHover: boolean;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.disableHover = AppConfig.isTouchScreen;

    if (!this.colorIsValid()) {
      this.color = 'primary';
    }

    this.renderer.addClass(this.el.nativeElement, this.color);
  }

  private colorIsValid() {
    return (this.color && this.color == 'primary') || this.color == 'secondary';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/buttons/round-button/round-button.component.ts